/* eslint-disable no-unused-vars */
import React from "react";
import { useLocation, useParams } from "react-router";
import { useDispatch } from "react-redux";
import { clearGetState } from "../actionsMethods/masterMethods";

import back_img from "../assests/images/rightVector.svg";
import right_arrow_white from "../assests/images/right-arrow-white.png";
import useCustomNavigate from "./customNavigationHook";

const Heading = ({
  title,
  navigateTo,
  id,
  nextPage,
  nextPageTitle,
  imgSrc,
  buttonClick,
  shipmentScanning,
  children,
  extraContent,
  custom = false,
  disableBackButton = false,
  backButtonClick,
}) => {
  const navigate = useCustomNavigate();
  const dispatch = useDispatch();
  const { type } = useParams();
  const history = useLocation();

  const goBack = () => {
    if (backButtonClick) {
      backButtonClick();
      return;
    }
    if (type === "OCR" || type === "API") {
      window.history.back();
      return;
    }

    if (custom) {
      navigate(navigateTo, { state: history?.state });
      return;
    }
    if (navigateTo) {
      navigate(navigateTo, { state: id });
    } else {
      window.history.back();
      dispatch(clearGetState());
    }
  };
  const nextButtonClick = () => {
    if (buttonClick) {
      buttonClick();
    } else {
      navigate(nextPage);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "baseline",
      }}
    >
      <p className="master-title-head" style={{ marginBottom: "5px" }}>
        {!disableBackButton ? (
          <img src={back_img} onClick={goBack} className="pointer" />
        ) : null}
        <span>{title}</span>
      </p>
      <div className="d-flex">
        {shipmentScanning}
        {nextPageTitle && (
          <button className="next-btn" onClick={nextButtonClick}>
            {imgSrc && (
              <img src={imgSrc} style={{ height: "18px", width: "18px" }} />
            )}
            &nbsp;&nbsp;{nextPageTitle}&nbsp;
            {imgSrc && (
              <img
                src={right_arrow_white}
                className="pointer"
                style={{ height: "12px", width: "12px" }}
              />
            )}
          </button>
        )}
        {extraContent && extraContent}
      </div>
      {children && <div>{children}</div>}
    </div>
  );
};
export default Heading;
